module.exports = __webpack_public_path__ + "media/about_employee/vermont_1-b94196b6.png";